import { render } from "./MainNavigation.vue?vue&type=template&id=4323a068"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"

import "./MainNavigation.vue?vue&type=style&index=0&id=4323a068&lang=scss"
script.render = render

export default script